import { TierartEnum } from '@ps20-frontend/frontend-models';
import { AnimalValidationContext, tierErrors } from './tier';
import { MAX_THH_TIERE } from './thhLimit';
import { TgvTier, TgvVorschaeden, TiergruppeState } from './tiergruppe.model';

export const MAX_VORSCHAEDEN = 4;

export const thhTiereMaximumError = (tiere: TgvTier[], tierart: TierartEnum): boolean =>
  tiere.filter(tier => tier.tierart === tierart && tier.umfang.thh).length > MAX_THH_TIERE;

export const vorschaedenRequiredError = (vorschaeden: TgvVorschaeden): boolean =>
  vorschaeden.vorhanden === null;

export const vorschaedenMaximumError = (vorschaeden: TgvVorschaeden): boolean =>
  vorschaeden.vorhanden === true && vorschaeden.anzahl > MAX_VORSCHAEDEN;

const vorschaedenInvalid = (vorschaeden: TgvVorschaeden): boolean =>
  vorschaedenRequiredError(vorschaeden) ||
  vorschaedenMaximumError(vorschaeden) ||
  (vorschaeden.vorhanden === true && vorschaeden.anzahl < 1);

/** The page can only be submitted when every card and every asked Vorschäden question is valid. */
export const isFormValid = (state: TiergruppeState, context: AnimalValidationContext): boolean => {
  const cardsValid = state.tiere.every(tier => tierErrors(tier, context).length === 0);
  const hundValid =
    state.positions.thhHund === null ||
    (!vorschaedenInvalid(state.vorschaeden.thhHund) &&
      !thhTiereMaximumError(state.tiere, TierartEnum.HUND));
  const pferdValid =
    state.positions.thhPferd === null ||
    (!vorschaedenInvalid(state.vorschaeden.thhPferd) &&
      !thhTiereMaximumError(state.tiere, TierartEnum.PFERD));
  return cardsValid && hundValid && pferdValid;
};

export const hasAnimalOfType = (state: TiergruppeState, tierart: TierartEnum): boolean =>
  state.tiere.some(tier => tier.tierart === tierart && tier.umfang.thh);
